import { struct } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../../../transaction/Id';

/** Body for the MTO invoice detail endpoint. */
export const DetailRequest = struct({
	transactionId: TransactionId,
});
